const moreSvg = `<svg aria-hidden='true' id='uw-symbol-more' viewBox='0,0,1792,1792'><title>More</title><path d='M979 960q0 13-10 23l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23zm384 0q0 13-10 23l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23z'></path></svg>`;

export default function mapObjectPopup(model) {
	return `<div class='content-wrapper' data-key='${model.key}'>
	<div class='popup-row'>
		${model.data.thumbnail ? `
			<div class='popup-col mo-img'>
				<img
					src='${model.data.thumbnail}'
					alt=''
					class='thumbnail'
					width='${model.data.thumbnailWidth}'
					height='${model.data.thumbnailHeight}'
				/>
			</div>
		` : ''}
		<div class='popup-col'>
			<h3 id='popup-name'>
				${model.data.name}
			</h3>
			<p id='popup-context'>${model.data.street_address}</p>
		</div>
	</div>
	<p class='align-right'>
		<button
			type='button'
			data-dialog-url='${model.htmlView}'
			data-photo-url='${model.data.images?.large || ''}'
			class='more_button'
		>
			More info
			<span class="uw-sr-only">about ${model.data.name}</span>
			${moreSvg}
		</button>
	</p>
</div>`;
}
